module.exports = {
  spacer10: "64px",
  spacer11: "72px",
  spacer01: "4px",
  spacer12: "80px",
  spacer02: "8px",
  spacer13: "88px",
  spacer03: "12px",
  spacer14: "96px",
  spacer04: "16px",
  spacer15: "104px",
  spacer05: "24px",
  spacer06: "32px",
  spacer07: "40px",
  spacer08: "48px",
  spacer09: "56px",
};